import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import PaymentsService from '@app/dev/services/payments';
import { formatMoneyAmount } from '@common/helpers/amount';
import { GetCurrencyConfig } from '@common/helpers/selectors';
import { waitForRegularCashoutResponse } from '@app/dev/helpers/cashout';
import { POPUPS } from '@common/constants/popups';

import { useBalance } from '../../../hooks/balance';
import { CashoutMoney, PartialCashoutMoney } from '../../../../actions/terminal';
import CashoutBase from '../base';

import OktopayLogo from '../../../../images/okto.png';

const CashoutOkto = ({ clearStateBeforeCashout }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ openPopup }] = useContext(PopupContext);
  const [loading, setLoading] = useState(false);
  const { playerInfo } = useSelector((state) => state.terminal);

  const currencyConfig = useSelector((state) => (
    GetCurrencyConfig(state, Config.main.currencySymbolRounding)
  ));

  const balance = useBalance();

  const onCashout = async (amount, isMax) => {
    if (loading) return {};

    if (Config.cashout.enablePartial && Number.isNaN(Number(amount))) return {};

    if (Config.cashout.enablePartial && Number(amount) > balance) {
      return { errorMessage: 'You don\'t have enough funds' };
    }

    const needDelayBeforeCashout = playerInfo?.PersonalId && clearStateBeforeCashout;

    if (needDelayBeforeCashout) {
      await PaymentsService.clearSessionBalanceState();
    }

    setTimeout(
      async () => {
        const action = Config.cashout.enablePartial && !isMax
          ? PartialCashoutMoney({ amount: Number(amount) })
          : CashoutMoney(null);

        dispatch(action);

        setLoading(true);
        const response = await waitForRegularCashoutResponse();

        setLoading(false);

        if (response.success) {
          openPopup(POPUPS.INFO, {
            icon: 'icon-circle-done static-green',
            title: 'Cash out successful!',
            buttonText: '',
            confirmButtonText: 'Ok',
            className: 'cashout-success-popup-content',
            subtitle: [
              'Cash out amount: {1}',
              <span key={1} className="color-hero">
                {formatMoneyAmount(
                  Config.cashout.enablePartial ? Number(amount) : balance,
                  Config,
                  currencyConfig,
                )}
              </span>,
            ],
          });
        }
      },
      needDelayBeforeCashout ? 1800 : 200,
    );

    return {};
  };

  return (
    <CashoutBase
      title="Cashout"
      description={(
        <p className="text-center">
          {t(Config.cashout.enablePartial ? 'Please input the cash out amount to your OktoPay account' : 'Do you wish to cash out to your OktoPay account')}
        </p>
      )}
      img={OktopayLogo}
      onSubmit={onCashout}
      timerVariant="oktopay-timer"
      confirmButtonClassName="oktopay-cashout"
    />
  );
};

export default CashoutOkto;
